import qwest from 'qwest';
import TrashBin from '../models/trashBin.jsx';

let TrashBinApi = {
  getList(recordType, timeframe, page, pageSize) {
    return new Promise((resolve, reject) => {
      qwest.get(`/TrashBin/List?recordType=${recordType}&timeFrame=${timeframe}&page=${page}&pageSize=${pageSize}`)
            .then((xhr, response) => {
              if (response.success) {
                resolve(response.data);
              } else {
                reject(response);
              }
            });
    });
  },


  restore(record) {
    return new Promise((resolve, reject) => {
      qwest.post('/TrashBin/Restore', record.toApiFormat())
      .then((xhr, response) => {
        if (response.success) {
          resolve(response.data);
        } else {
          reject(response);
        }
      });
    });
  },

};

export default TrashBinApi;
